<template>

    <div class="min-h-screen flex flex-col">

        <navbar></navbar>

        <div class="flex-1 mb-10">

            <!-- Header -->
            <section class="p-20 topo-bkg" :style="{'background-image': 'url(' + require('@/assets/images/stormy-bkg.jpg') + ')'}" style="background-size: cover; background-position: center center; padding-top:10em; padding-bottom: 10em;">

                <div class="md:px-0 container mx-auto px-5 text-center" style="margin-bottom: 20em;">
                    <h1 class="text-white uppercase text-5xl">Live Storm Chasing | Blog</h1>
                    <h4 class="text-white text-xl pt-2">A collection of materials from meterologists, chasers, and developers.</h4>
                </div>

            </section>

            <div class="container mx-auto" style="margin-top: -20em">

                <div class="w-full text-xl md:text-2xl text-grey-darkest leading-normal rounded-t">

    			<!--Lead Card-->
    			<div class="flex h-full bg-white rounded overflow-hidden shadow-lg">
    				<a href="/blog/relaunch-the-storm-awaits" class="flex flex-wrap no-underline hover:no-underline">
    					<div class="w-full md:w-2/3 rounded-t">
    						<img :src="require('@/assets/images/new-site.png')" class="h-full w-full shadow">
    					</div>

    					<div class="w-full md:w-1/3 flex flex-col flex-grow flex-shrink">
    						<div class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow-lg">
    							<p class="w-full text-grey-dark text-xs md:text-sm pt-6 px-6 uppercase">Site Updates</p>
    							<div class="w-full font-bold text-xl text-black px-6">Live Storm Chasing: A Storm Awaits</div>
    							<p class="text-grey-darkest font-serif text-base px-6 mb-5">
    								After nearly 2 years since launch, I figured it was time to make Live Storm Chasing how I originally invisoned the platform.
    							</p>
    						</div>

    						<div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6">
    							<div class="flex items-center justify-between">
                                    <img class="w-8 h-8 rounded-full mr-4 avatar" data-tippy-content="Author Name" src="//www.gravatar.com/avatar/54604fb09b5bd0c03fa56e3fdc74ed1b?s=80&d=retro&r=g" alt="Avatar of Author" tabindex="0">
                                    <p class="text-grey-dark text-xs md:text-sm">March 23, 2019 &middot; 6 MIN READ</p>
    							</div>
    						</div>
    					</div>

    				</a>
    			</div>
    			<!--/Lead Card-->

    			<!--Posts Container-->
    			<!-- <div class="flex flex-wrap justify-between pt-12 -mx-6">


    				<div class="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
    					<div class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow-lg">
    						<a href="#" class="flex flex-wrap no-underline hover:no-underline">
    							<img src="https://source.unsplash.com/collection/225/800x600" class="h-64 w-full rounded-t pb-6">
    							<p class="w-full text-grey-dark text-xs md:text-sm px-6">GETTING STARTED</p>
    							<div class="w-full font-bold text-xl text-black px-6">Lorem ipsum dolor sit amet.</div>
    							<p class="text-grey-darkest font-serif text-base px-6 mb-5">
    								Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam at ipsum eu nunc commodo posuere et sit amet ligula.
    							</p>
    						</a>
    					</div>
    					<div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6">
    						<div class="flex items-center justify-between">
    							<img class="w-8 h-8 rounded-full mr-4 avatar" data-tippy-content="Author Name" src="http://i.pravatar.cc/300" alt="Avatar of Author" tabindex="0">
    							<p class="text-grey-dark text-xs md:text-sm">1 MIN READ</p>
    						</div>
    					</div>
    				</div>



    				<div class="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
    					<div class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow-lg">
    						<a href="#" class="flex flex-wrap no-underline hover:no-underline">
    							<img src="https://source.unsplash.com/collection/3106804/800x600" class="h-64 w-full rounded-t pb-6">
    							<p class="w-full text-grey-dark text-xs md:text-sm px-6">GETTING STARTED</p>
    							<div class="w-full font-bold text-xl text-black px-6">Lorem ipsum dolor sit amet.</div>
    							<p class="text-grey-darkest font-serif text-base px-6 mb-5">
    								Lorem ipsum dolor sit amet, consectetur adipiscing elit. ipsum dolor sit amet, consectetur adipiscing elit. Aliquam at ip Aliquam at ipsum eu nunc commodo posuere et sit amet ligula.
    							</p>
    						</a>
    						</div>
    					<div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6">
    						<div class="flex items-center justify-between">
    							<img class="w-8 h-8 rounded-full mr-4 avatar" data-tippy-content="Author Name" src="http://i.pravatar.cc/300" alt="Avatar of Author" tabindex="0">
    							<p class="text-grey-dark text-xs md:text-sm">1 MIN READ</p>
    						</div>
    					</div>
    				</div>

    				<div class="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
    					<div class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow-lg">
    						<a href="#" class="flex flex-wrap no-underline hover:no-underline">
    							<img src="https://source.unsplash.com/collection/539527/800x600" class="h-64 w-full rounded-t pb-6">
    							<p class="w-full text-grey-dark text-xs md:text-sm px-6">GETTING STARTED</p>
    							<div class="w-full  font-bold text-xl text-black px-6">Lorem ipsum dolor sit amet.</div>
    							<p class="text-grey-darkest font-serif text-base px-6 mb-5">
    								Lorem ipsum eu nunc commodo posuere et sit amet ligula.
    							</p>
    						</a>
    					</div>
    					<div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6">
    						<div class="flex items-center justify-between">
    							<img class="w-8 h-8 rounded-full mr-4 avatar" data-tippy-content="Author Name" src="http://i.pravatar.cc/300" alt="Avatar of Author" tabindex="0">
    							<p class="text-grey-dark text-xs md:text-sm">1 MIN READ</p>
    						</div>
    					</div>
    				</div>


    				<div class="w-full md:w-1/2 p-6 flex flex-col flex-grow flex-shrink">
    					<div class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow-lg">
    						<a href="#" class="flex flex-wrap no-underline hover:no-underline">
    							<img src="https://source.unsplash.com/collection/3657445/800x600" class="h-full w-full rounded-t pb-6">
    							<p class="w-full text-grey-dark text-xs md:text-sm px-6">GETTING STARTED</p>
    							<div class="w-full font-bold text-xl text-black px-6">Lorem ipsum dolor sit amet.</div>
    							<p class="text-grey-darkest font-serif text-base px-6 mb-5">
    								Lorem ipsum eu nunc commodo posuere et sit amet ligula.
    							</p>
    						</a>
    					</div>
    					<div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6">
    						<div class="flex items-center justify-between">
    							<img class="w-8 h-8 rounded-full mr-4 avatar" data-tippy-content="Author Name" src="http://i.pravatar.cc/300" alt="Avatar of Author" tabindex="0">
    							<p class="text-grey-dark text-xs md:text-sm">1 MIN READ</p>
    						</div>
    					</div>
    				</div>


    				<div class="w-full md:w-1/2 p-6 flex flex-col flex-grow flex-shrink">
    					<div class="flex-1 flex-row bg-white rounded-t rounded-b-none overflow-hidden shadow-lg">
    						<a href="#" class="flex flex-wrap no-underline hover:no-underline">
    							<img src="https://source.unsplash.com/collection/764827/800x600" class="h-full w-full rounded-t pb-6">
    							<p class="w-full text-grey-dark text-xs md:text-sm px-6">GETTING STARTED</p>
    							<div class="w-full font-bold text-xl text-black px-6">Lorem ipsum dolor sit amet.</div>
    							<p class="text-grey-darkest font-serif text-base px-6 mb-5">
    								Lorem ipsum eu nunc commodo posuere et sit amet ligula.
    							</p>
    						</a>
    					</div>
    					<div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6">
    						<div class="flex items-center justify-between">
    							<img class="w-8 h-8 rounded-full mr-4 avatar" data-tippy-content="Author Name" src="http://i.pravatar.cc/300" alt="Avatar of Author" tabindex="0">
    							<p class="text-grey-dark text-xs md:text-sm">1 MIN READ</p>
    						</div>
    					</div>
    				</div>




    				<div class="w-full md:w-2/3 p-6 flex flex-col flex-grow flex-shrink">
    					<div class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow-lg">
    						<a href="#" class="flex flex-wrap no-underline hover:no-underline">
    							<img src="https://source.unsplash.com/collection/325867/800x600" class="h-full w-full rounded-t pb-6">
    							<p class="w-full text-grey-dark text-xs md:text-sm px-6">GETTING STARTED</p>
    							<div class="w-full font-bold text-xl text-black px-6">Lorem ipsum dolor sit amet.</div>
    							<p class="text-grey-darkest font-serif text-base px-6 mb-5">
    								Lorem ipsum eu nunc commodo posuere et sit amet ligula.
    							</p>
    						</a>
    					</div>
    					<div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6">
    						<div class="flex items-center justify-between">
    							<img class="w-8 h-8 rounded-full mr-4 avatar" data-tippy-content="Author Name" src="http://i.pravatar.cc/300" alt="Avatar of Author" tabindex="0">
    							<p class="text-grey-dark text-xs md:text-sm">1 MIN READ</p>
    						</div>
    					</div>
    				</div>


    				<div class="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
    					<div class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow-lg">
    						<a href="#" class="flex flex-wrap no-underline hover:no-underline">
    							<img src="https://source.unsplash.com/collection/1118905/800x600" class="h-full w-full rounded-t pb-6">
    							<p class="w-full text-grey-dark text-xs md:text-sm px-6">GETTING STARTED</p>
    							<div class="w-full font-bold text-xl text-black px-6">Lorem ipsum dolor sit amet.</div>
    							<p class="text-grey-darkest font-serif text-base px-6 mb-5">
    								Lorem ipsum eu nunc commodo posuere et sit amet ligula.
    							</p>
    						</a>
    					</div>
    					<div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6">
    						<div class="flex items-center justify-between">
    							<img class="w-8 h-8 rounded-full mr-4 avatar" data-tippy-content="Author Name" src="http://i.pravatar.cc/300" alt="Avatar of Author" tabindex="0">
    							<p class="text-grey-dark text-xs md:text-sm">1 MIN READ</p>
    						</div>
    					</div>
    				</div>

    			</div> -->
            </div></div>


        </div>

        <page-footer></page-footer>

    </div>
</template>

<script>

    import * as Config from '../config'

    import VideoOnDemandPlayer from '@/components/VideoOnDemandPlayer'
    import Navbar from '@/components/Navbar'
    import PageFooter from '@/components/PageFooter'
    import { Carousel, Slide } from 'vue-carousel';
    import Gravatar from 'vue-gravatar';

    export default {
        name: 'home',
        components: {
            VideoOnDemandPlayer,
            PageFooter,
            Carousel,
            Slide,
            Gravatar,
            Navbar
        },
        data() {
            return {
                open: false,
                randomChasers: []
            }
        },
        mounted() {
            this.getRandomChasers()
        },
        methods: {
            toggle() {
                this.open = !this.open
            },
            getRandomChasers() {
                this.$http.get(Config.apiPath + "/api/v1/chasers/random?limit=10").then((response) => {
                    this.$set(this, 'randomChasers', response.data);
                });
            }
        },
    }

</script>

<style>
    .navbar-logo {
        max-height: 40px;
        width: auto;
    }
    .embed-responsive.embed-responsive-16by9 {
        padding-bottom: 56.25%;
    }
    .embed-responsive {
        position: relative;
        display: block;
        height: 0;
        padding: 0;
        overflow: hidden;
    }
    .embed-responsive .embed-responsive-item, .embed-responsive iframe, .embed-responsive embed, .embed-responsive object {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
